import { ModelInvocationStatus } from '../contentqnaPluginTypes';

export class GenerationDeclinedByLLMError extends Error {
	public constructor(
		public declinationType: Omit<
			ModelInvocationStatus,
			ModelInvocationStatus.Ok | ModelInvocationStatus.Unknown
		> = ModelInvocationStatus.DeclinedUnknown
	) {
		super('Generation declined: ' + declinationType);
		this.name = 'GenerationDeclinedError';
	}
}
